export const getCurrencySymbol = (currencyCode: string): string => {
  switch (currencyCode?.toUpperCase()) {
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    case 'GBP':
      return '£';
    default:
      return currencyCode; // fallback to currency code if symbol not found
  }
};

export const formatAmount = (amount: number, currency: string): string => {
  return `${getCurrencySymbol(currency)}${amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
}; 